import { render, staticRenderFns } from "./VoiceHeader.vue?vue&type=template&id=37d326f7&scoped=true"
import script from "./VoiceHeader.vue?vue&type=script&lang=js"
export * from "./VoiceHeader.vue?vue&type=script&lang=js"
import style0 from "./VoiceHeader.vue?vue&type=style&index=0&id=37d326f7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d326f7",
  null
  
)

export default component.exports